export default "__VITE_ASSET__ChXR3Hkx__"